import styled from 'styled-components'
import TextField from '../TextField'

export const StyledTextField = styled(TextField)``
